import React from 'react'
import { Spirit } from '../../Common/SI'
import { ExpansionIndicator } from '../ExpansionIndicator'
import { SpiritName } from '../SpiritName'
import { useFilters } from '../../Common/Hooks/useFilters'

export interface SpiritLinkProps {
	spirit: Spirit
}

export function SpiritLink(props: SpiritLinkProps): JSX.Element {

	const { addFilter } = useFilters()

	return (
		<React.Fragment>
			<ExpansionIndicator expansion={props.spirit.expansion} />
			{
				// eslint-disable-next-line jsx-a11y/anchor-is-valid
				<a className='filter' href='#' onClick={(e) => {
					e.preventDefault()
					addFilter('spirits', props.spirit.name)
				}}>
					<SpiritName spirit={props.spirit}></SpiritName>
				</a>
			}
		</React.Fragment>
	)
}
